import { useTranslation } from 'react-i18next';
import { usePriceGroup } from 'core/contexts/priceGroup';
import { Form } from 'react-final-form';
import { Box, FormHelperText } from '@mui/material';
import ActionButtons from '../ActionButtons';
import Title from 'modules/Pricing/components/Title';

const DeleteUnit = ({ priceGroupId, handleClose, unitToDelete }) => {
    const { t } = useTranslation();
    const translate = (key) => t(`price_group_id.delete_unit.${key}`);
    const { submittingPriceGroup, deleteUnit } = usePriceGroup();

    const handleSubmit = async (values) => {
        await deleteUnit(priceGroupId, values.unitId, values.name);
        handleClose();
    };

    const validateForm = (values) => {
        const errors = {};

        if (!values.id) errors.delete = translate('validate_form.id');

        return errors;
    };

    if (!unitToDelete?.unitId) {
        handleClose();
        return;
    }

    return (
        <Form
            key={`delete-price-group-units-${priceGroupId}`}
            onSubmit={handleSubmit}
            validate={validateForm}
            initialValues={{ ...unitToDelete }}
            render={({ errors, handleSubmit, form }) => (
                <form key={`delete-price-group-units-${priceGroupId}`} onSubmit={handleSubmit} noValidate>
                    <Box component="section" py={2}>
                        <Title title={`${translate('title')} ${unitToDelete?.name}`} description={`${translate('description')} ${unitToDelete?.name}?`} />

                        {errors.delete && (
                            <FormHelperText error={errors.delete} sx={{ my: 1 }}>
                                {errors.delete}
                            </FormHelperText>
                        )}

                        <ActionButtons
                            handleSubmit={(e) => {
                                return handleSubmit(e);
                            }}
                            handleClose={(e) => {
                                handleClose();
                                return form.reset(e);
                            }}
                            submitting={submittingPriceGroup}
                            labelNext={translate('delete')}
                        />
                    </Box>
                </form>
            )}
        />
    );
};

export default DeleteUnit;
